import {useQuery, UseQueryResult} from '@tanstack/react-query'

import {QueryKeyName, getMonthlyDataPoints} from '../../common/backend'
import {MonthlyDataPointsPayload, MonthlyHierarchyAnalysisDataPoint} from '../../types'

export const useMonthlyDataPoints = (
  params: MonthlyDataPointsPayload,
  options?: {enabled?: boolean}
): UseQueryResult<MonthlyHierarchyAnalysisDataPoint[]> => {
  return useQuery({
    queryKey: [QueryKeyName.GetMonthlyDataPoints, params],
    queryFn: () => getMonthlyDataPoints(params),
    staleTime: Infinity,
    enabled: options?.enabled
  })
}
